module.exports = __webpack_public_path__ + "static/timothy-0b01381755a937c069a258902a4eb617.png";